<script>
	import Component from './Component.svelte'
	import Driver from './Driver.svelte'

  let config = {
    preheader: 'Check it out',
    title: 'Before they sold out readymade gluten!',
    subtitle: 'Wow tho.',
    body: 'Copper mug try-hard pitchfork pour-over freegan heirloom neutra air plant cold-pressed tacos poke beard tote bag. Heirloom echo park mlkshk tote bag selvage hot chicken authentic tumeric truffaut hexagon try-hard chambray.',
    actions: [{
      url: '/',
      cta: 'Buy Now',
      color: 'purple'
    }, {
      url: '/',
      cta: 'Learn More',
      color: 'gray'
    }],
    figure: {
      alt: 'Two color (blue/red) risograph print of David by Jordan Kay',
      url: 'https://cdn2.shopify.com/s/files/1/1630/2135/files/bust-ig.jpg',
      attribution: {
        url: '/wow',
        cta: 'Jordan Kay'
      }
    }
  }
</script>

<main>
	<Component {config} />
	<hr>
	<Component {config} labels={true}/>
	<hr>
	<Component {config} docs={true}/>
	<hr>
	<Driver	{config} />
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
	
	br {

	}

</style>